// extracted by mini-css-extract-plugin
export default {"federatedIDPList":"styles_federatedIDPList__OhBZt"};